export default {
  variantProductPageTitle: {
    id: 'product_meta_title',
    defaultMessage: '{title}',
  },
  masterProductPageTitle: {
    id: 'product_master_pp_meta_title',
    defaultMessage: '{title} Refurbished',
  },
}
